<template>
    <div class="v_card">
        <div class="top">
            <img src="../../assets/vcard/top.jpg" alt="">
            <div class="click" @click="getVcard()"></div>
        </div>
        <div class="btm">
            <img src="../../assets/vcard/btm.jpg" alt="">
        </div>
        <div class="out_none" v-if="isShow" @click="colseIn()" >
            <div class="in_content">
                <div class="top_bg"></div>
                <div class="mid_content">
                    <img src="../../assets/vcard/success.png" alt="">
                    <span>领取成功</span> 
                </div>
                <div class="btm_btn">
                    <div class="left" @click="back()">返回公众号</div>
                    <div class="right" @click="goShop()">
                        <span>马上购物</span>
                        <img src="../../assets/vcard/into.png" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TiyanVcard from "../../services/Vcard-titan.js";
import MbrService from "../../services/mbrservice.js";
export default {
    name: 'vcard',
    data() {
        return {
            isShow: false
        }
    },
    mounted() {
       let gotoUrl = localStorage.getItem('isShowIn');
       if(gotoUrl){
           this.isShow = true
       }
    },
    methods: {
        // 领取体验券
        getVcard() {
            if(this.$route.query.actid) {
                new TiyanVcard().getVcard({"ActId": this.$route.query.actid,"Kind": "VCard"}).then(res => {
                    if(res.ErrorCode == 0){
                        new MbrService().LaodMemberInfo().then(data => {
                            // 如果有返回登陆者信息（暂时以登陆者手机号作为判断依据）
                            if(data.Data && data.Data.Phone != null) {
                                this.isShow = true
                            } else {
                                this.$router.push({ path: "/info" });
                            }
                        })
                    } else if(res.ErrorCode == 1) {
                        alert(res.ErrorMessage)
                    } else {
                        alert("领取失败")
                    }
                })
            } 
        },
        // 马上购物
        goShop() {
            location.href = "https://gdtvcms.gdtvdv.com/Mass/shop/index.html?vscf=&origin=#/home"
        },
        // 返回公众号
        back() {
            WeixinJSBridge.call('closeWindow');
        },
        colseIn() {
            this.isShow = false
        }
    },
    watch: {
     
    },
    destroyed() {
        localStorage.setItem('isShowIn', false);
    }
}

</script>
<style scoped>

    .top{
        float: left;
        position: relative;
    }
    .top .click{
        position: absolute;
        left: 0;
        bottom: 13.5%;
        width: 100%;
        height: 50%;
    }
    .btm{
        float: left;
    }
    img{
        width: 100%;
        height: 100%;
        display: block;
    }
    .out_none{
        position: fixed;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
    }
    .in_content{
        background: #fff;
        position: absolute;
        width: 80%;
        top: 25%;
        left: 10%;
        height: 4.2rem;
        border-radius: 0.2rem;
        overflow: hidden;
    }
    .in_content .top_bg{
        height: 0.6rem;
        background: #ffd88b;
    }
    .in_content .mid_content{
        height: 2.2rem;
        line-height: 2.2rem;
        font-size: 0.5rem;
        text-align: center;
        letter-spacing: 0.2rem;
        font-weight: bold;
        color: #6e6560;
        position: relative;
    }
    .in_content .mid_content span{
        padding-left: 1.5rem;
    }
    .in_content .mid_content img{
        width: 1rem;
        height: 1rem;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 15%;
    }
    .in_content .btm_btn{
        height: 1.4rem;
    }
    .in_content .btm_btn .left{
        float: left;
        width: 42%;
        height: 0.7rem;
        margin-left: 5%;
        line-height: 0.7rem;
        text-align: center;
        border: 1px solid #9c9c9c;
        border-radius: 1.2rem;
        font-size: 14px;
        color: #606060;
        letter-spacing: 3px;
    }
    .in_content .btm_btn .right{
        float: right;
        width: 42%;
        height:0.7rem;
        font-size: 14px;
        margin-right: 5%;
        line-height: 0.7rem;
        text-align: center;
        background: #eb493e;
        color: #fff;
        border-radius: 1.2rem;
        letter-spacing: 3px;
        position: relative;
    }
    .in_content .btm_btn .right span{
        padding-right: 0.2rem;
    }
    .in_content .btm_btn .right img{
        position: absolute;
        width: 0.4rem;
        height: 0.4rem;
        top: 50%;
        transform: translateY(-50%);
        right: 10%;
    }

</style>


// WEBPACK FOOTER //
// src/component/Vcard/VcardTiyan.vue